import _ from 'lodash'
import api from '../../api'
import * as types from '../../types'

export default {
  state: {
    bankcardList: [],
    cardTypeList: [],
    regionData: [],
    selectedBankId: '',
    selectedBankNO: '',
    bankUserName: '',
    customerType: 1
  },
  getters: {
    [types.GET_BANKCARD_LIST]: state => state.bankcardList,
    [types.GET_CARD_TYPE_LIST]: state => state.cardTypeList,
    [types.GET_REGION_DATA]: state => state.regionData,
    [types.GET_SELECTED_BANK_ID_STATE]: state => state.selectedBankId,
    [types.GET_SELECTED_BANK_NO_STATE]: state => state.selectedBankNO,
    [types.GET_BANKCARD_LIST_NAME]: state => state.bankUserName,
    [types.GET_BANKCARD_LIST_NAME_TYPE]: state => state.customerType
  },
  actions: {
    [types.SET_BANKCARD_LIST] ({dispatch, commit}, params) {
      api.getBankcardListData({
        token: params.token,
        frontApplyId: params.id
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_BANKCARD_LIST_STATE, resData.data)
          commit(types.SET_BANKCARD_LIST_NAME_TYPE, resData.customerType)
          if (res.data.customerName) {
            commit(types.SET_BANKCARD_LIST_NAME, res.data.customerName)
          } else {
             //params.router.push('/personalCenter/realNameAuth')
          }
          /* commit(types.SELECT_BANKCARD, {
            bankAccountId: params.selectedBankcardId || resData.data.selectedBankId
          })
          commit(types.SET_SELECTED_BANK_ID_STATE, resData.data.selectedBankId)
          commit(types.SET_SELECTED_BANK_NO_STATE, resData.data.selectedBankName) */
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '银行卡列表信息获取错误'
          })
        }
      })
    },
    [types.SAVE_BANKCARD_INFO] ({dispatch, commit}, params) {
      return api.saveBankcardInfo({
        token: params.token,
        customerId: params.customerId,
        bankType: params.bankType,
        bankUserName: params.bankUserName,
        bankAccountName: params.bankAccountName,
        bankName: params.bankName,
        bankBranchName: params.bankBranchName,
        bankAccountId: params.bankAccountId,
        bankCounty: params.bankCounty,
        bankProvince: params.bankProvince,
        bankCity: params.bankCity,
        bankUseType:params.bankUseType,
        bankSwift:params.bankSwift
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          dispatch(types.SET_SUCCESS_MESSAGE, {
            show: true,
            content: resData.result
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '银行卡明细获取错误'
          })
        }
        return res
      })
    },
    [types.SET_PROVINCE_DATA] ({dispatch, commit}) {
      api.getProvinceData().then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_PROVINCE_STATE, resData.data.map((item) => {
            item.children = []
            return item
          }))
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '省份信息获取错误'
          })
        }
      })
    },
    [types.SET_CITY_AND_DISTRICT_DATA] ({dispatch, commit}, params) {
      const val = params.val
      return api.getCityAndDistrictData({
        code: val.length === 1 ? val[0] : val[1]
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_CITY_AND_DISTRICT_STATE, {
            val: params.val,
            data: resData.data
          })
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '城市区县信息获取错误'
          })
        }
      })
    },
    [types.DELETE_BANKCARD_INFO] ({dispatch, commit}, params) {
      return api.deleteBankcardInfo({
        token: params.token,
        bankAccountId: params.bankAccountId
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          dispatch(types.SET_SUCCESS_MESSAGE, {
            show: true,
            content: resData.result
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '银行卡删除失败'
          })
        }
      })
    }
  },
  mutations: {
    [types.SET_SELECTED_BANK_ID_STATE] (state, data) {
      if(data){
        state.selectedBankId = data
      }else {
        state.selectedBankId = state.bankcardList[0] ? state.bankcardList[0].bankAccountId : ''
      }
    },
    [types.SET_SELECTED_BANK_NO_STATE] (state, data) {
      state.selectedBankNO = data
    },
    [types.SET_BANKCARD_LIST_NAME] (state, data) {
      state.bankUserName = data
    },
    [types.SET_BANKCARD_LIST_STATE] (state, data) {
      state.bankcardList = data.result
      state.cardTypeList = data.accountType
    },
    [types.SET_BANKCARD_LIST_NAME_TYPE] (state, data) {
      state.customerType = data
    },
    [types.SET_PROVINCE_STATE] (state, data) {
      state.regionData = data
    },
    [types.SET_CITY_AND_DISTRICT_STATE] (state, data) {
      const val = data.val
      const resData = data.data
      const selectedProvince = _.find(state.regionData, item => item.code === val[0])

      // 查询不到下级的话，resData.data = undefined
      if (resData) {
        if (val.length === 1) {
          // 选择市
          if (!selectedProvince.children.length && resData.length) {
            selectedProvince.children = resData.map((item) => {
              item.children = []
              return item
            })
          }
        } else {
          // 选择区县
          const selectedCity = _.find(selectedProvince.children, item => item.code === val[1])
          if (!selectedCity.children.length && resData.length) {
            selectedCity.children = resData
          }
        }
      }
    },
    [types.SELECT_BANKCARD] (state, data) {
      // 无法检测更新
      // state.bankcardList.forEach((item) => {
      //   item.selected = item.bankAccountId === data.bankAccountId
      // })
      // 这样才能正确检测更新渲染列表，囧
      const bankcardList = state.bankcardList
      if (bankcardList.length > 1) {
        if(data.bankAccountId){
          for (let i = 0; i < bankcardList.length; i++) {
            state.bankcardList.splice(i, 1, Object.assign(bankcardList[i], {
              selected: bankcardList[i].bankAccountId === data.bankAccountId
            }))
          }
        }else {
          state.bankcardList.splice(0, 1, Object.assign(bankcardList[0], {
            selected: true
          }))
        }
      } else if (bankcardList.length === 1) {
        // 当只有一张银行卡的时候，自动选择第一张卡
        state.bankcardList.splice(0, 1, Object.assign(bankcardList[0], {
          selected: true
        }))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common/bankcardList.js